import { Badge } from "@/components/ui/badge";
import { useAppDispatch, useAppState } from "@/store/useApp";
import { GradingCriteria } from "@/types/grading";

import { XCircle } from "lucide-react";
import FeedbackPublishedAlert from "./FeedbackPublishedAlert";

const GradingReport = () => {
  const grading = useAppState((state) => state.grading);
  const gradingPanel = useAppState((state) => state.gradingPanel);
  const dispatch = useAppDispatch();

  const handleCriterionClick = (criterion: GradingCriteria) => {
    const isSelected =
      gradingPanel.visible &&
      gradingPanel.view === "remarks" &&
      gradingPanel.selectedCriterionId === criterion.id;

    if (isSelected) {
      dispatch({
        type: "SHOW_GRADING_PANEL",
        payload: { visible: false },
      });
    } else {
      dispatch({
        type: "SHOW_GRADING_PANEL",
        payload: {
          visible: true,
          view: "remarks",
          selectedCriterionId: criterion.id,
        },
      });
    }
  };

  return (
    <div className="pb-40">
      <div className="max-w-2xl mx-auto flex flex-col justify-center overflow-y">
        <FeedbackPublishedAlert />

        {grading?.criteria.map((criterion) => (
          <div key={criterion.id} className="p-4">
            <div className="mb-4">
              <div className="space-y-2">
                <h4>{criterion.title}</h4>

                {criterion.summary && criterion.summary.length > 0 ? (
                  <div className="flex items-center justify-between gap-2 pt-4 pb-6">
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-muted-foreground">
                        AI recommends:
                      </span>
                      <Badge
                        variant="secondary"
                        className="bg-purple-50 text-purple-600"
                      >
                        {criterion.rating}
                      </Badge>
                    </div>
                    {criterion?.suggestions.length > 0 && (
                      <Badge
                        variant={
                          gradingPanel.visible &&
                          gradingPanel.view === "remarks" &&
                          gradingPanel.selectedCriterionId === criterion.id
                            ? "default"
                            : "secondary"
                        }
                        className="cursor-pointer"
                        onClick={() => handleCriterionClick(criterion)}
                      >
                        {gradingPanel.visible &&
                        gradingPanel.view === "remarks" &&
                        gradingPanel.selectedCriterionId === criterion.id ? (
                          <>
                            Hide remarks
                            <XCircle className="h-3 w-3 ml-1" />
                          </>
                        ) : (
                          "Show remarks"
                        )}
                      </Badge>
                    )}
                  </div>
                ) : (
                  <div className="flex items-center gap-2 mt-4 mb-6">
                    <span className="text-sm text-muted-foreground">
                      AI recommends:
                    </span>
                    <Badge variant="secondary">No recommendation</Badge>
                  </div>
                )}
                {criterion.summary && criterion.summary.length > 0 && (
                  <ul className="mt-2">
                    {criterion.summary.map((item, index) => (
                      <li key={index} className="text-sm">
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
                {(!criterion.summary || criterion.summary.length === 0) && (
                  <p className="mt-2 text-muted-foreground">
                    No grading remarks available
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GradingReport;
